import { useGetUsersWithAnyOfPermissions } from "@/spz-api/companies/companies";
import { GetUsersWithAnyOfPermissionsPermissionIdsItem } from "@/spz-api/model";
import { keepPreviousData } from "@tanstack/react-query";

export const useOwnersList = (companyId: string) => {
  const { data, isLoading, error } = useGetUsersWithAnyOfPermissions(
    companyId,
    {
      permissionIds: [
        GetUsersWithAnyOfPermissionsPermissionIdsItem["spz:control:view"],
      ],
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  return { owners: data?.data ?? [], isLoading, error: error ?? undefined };
};
